export default __webpack_public_path__ + "static/media/addOnBenefitshelpHighlight.8267dbc8.png";